var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert--card"},[_c('v-icon',{staticClass:"alert--icon"},[_vm._v(_vm._s(_vm.icon))]),_c('h3',{staticClass:"alert--text"},[_vm._v(_vm._s(_vm.text))]),_c('h3',{staticClass:"alert--text"},[_vm._v(_vm._s(_vm.subtext))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }